export const menuShrink = () => {
    window.addEventListener('scroll', toggleClass);
};

const toggleClass = () => {
    if (window.pageYOffset > 1) {
        document.querySelector('.header').classList.add('header--shrinked');
    } else {
        document.querySelector('.header').classList.remove('header--shrinked');
    }
};

export const clearListener = () => {
    window.removeEventListener('scroll', toggleClass);
};
